import React, { useContext, useState } from "react";
import styled from "styled-components";
import { HamburgerIcon } from "../../assets/svg/HamburgerIcon";
import { DashboardIcon } from "../../assets/svg/DashboardIcon";
import { ScorecardIcon2 } from "../../assets/svg/ScorecardIcon2";
import { StrategyMapIcon } from "../../assets/svg/StrategyMapIcon";
import { CalendarIcon } from "../../assets/svg/CalendarIcon";
import { TimeBoardIcon } from "../../assets/svg/TimeBoardIcon";
import { SettingsIcon } from "../../assets/svg/SettingsIcon";
import { useRouteMatch, NavLink, Route } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { CircleIcon2 } from "../../assets/svg/CircleIcon2";
import { ApprovalsIcon } from "../../assets/svg/ApprovalsIcon";
import useAuth from "../../hooks/useAuth";

export const SideBar = () => {
  const { url } = useRouteMatch();
  const auth = useAuth();
  const { isAdmin, isManager } = auth;
  const [isExpanded, setIsExpanded] = useState(true);

  const superUser = isAdmin() || isManager();

  const handleToggle = () => {
    setIsExpanded((prevState) => !prevState);
  };

  return (
    <SideBarContainer isExpanded={isExpanded}>
      <HamburgerContainer onClick={handleToggle} title={isExpanded ? "Collapse" : "Expand"}>
        <HamburgerIcon />
      </HamburgerContainer>
      <StyledNavLink to={`${url}/dashboard`} title={!isExpanded ? "Home" : ""}>
        <Route>
          {(props) => {
            const matches = props.location.pathname === `${url}/dashboard`;
            return <DashboardIcon isActive={matches} />;
          }}
        </Route>
        <SideBarText isExpanded={isExpanded}>Home</SideBarText>
      </StyledNavLink>

      <StyledNavLink to={`${url}/strategymap`} title={!isExpanded ? "Strategy Map" : ""}>
        <Route>
          {(props) => {
            const matches = props.location.pathname === `${url}/strategymap`;
            return <StrategyMapIcon isActive={matches} />;
          }}
        </Route>
        <SideBarText isExpanded={isExpanded}>Strategy Map</SideBarText>
      </StyledNavLink>
      <StyledNavLink to={`${url}/scorecard`} title={!isExpanded ? "Scorecard" : ""}>
        <Route>
          {(props) => {
            const matches = props.location.pathname === `${url}/scorecard/summary`;
            return <CircleIcon2 isActive={matches} />;
          }}
        </Route>
        <SideBarText isExpanded={isExpanded}>Scorecard</SideBarText>
      </StyledNavLink>

      {superUser && (
        <StyledNavLink to={`${url}/plan`} title={!isExpanded ? "Initiatives" : ""}>
          <Route>
            {(props) => {
              const matches = props.location.pathname === `${url}/plan/initiatives`;
              return <CalendarIcon isActive={matches} />;
            }}
          </Route>
          <SideBarText isExpanded={isExpanded}>Initiatives</SideBarText>
        </StyledNavLink>
      )}

      <StyledNavLink to={`${url}/timeboard`} title={!isExpanded ? "Tasks" : ""}>
        <Route>
          {(props) => {
            const matches = props.location.pathname === `${url}/timeboard`;
            return <TimeBoardIcon isActive={matches} />;
          }}
        </Route>
        <SideBarText isExpanded={isExpanded}>Tasks</SideBarText>
      </StyledNavLink>

      {superUser && (
        <StyledNavLink to={`${url}/approvals`} title={!isExpanded ? "Approvals" : ""}>
          <Route>
            {(props) => {
              const matches = props.location.pathname === `${url}/approvals`;
              return <ApprovalsIcon isActive={props.location.pathname.includes("approvals")} />;
            }}
          </Route>
          <SideBarText isExpanded={isExpanded}>Approvals</SideBarText>
        </StyledNavLink>
      )}

      <StyledNavLink to={`${url}/settings`} title={!isExpanded ? "Settings" : ""}>
        <Route>
          {(props) => {
            const matches = props.location.pathname === `${url}/settings`;
            return <SettingsIcon isActive={props.location.pathname.includes("settings")} />;
          }}
        </Route>
        <SideBarText isExpanded={isExpanded}>Settings</SideBarText>
      </StyledNavLink>
    </SideBarContainer>
  );
};

const SideBarContainer = styled.div<{ isExpanded: boolean }>`
  display: grid;
  position: relative;
  grid-template-rows: 7em repeat(7, 5em);
  width: ${({ isExpanded }) => (isExpanded ? "6em" : "4.5em")};
  transition: width 0.3s ease-in-out;
  height: 100vh;
  box-shadow: 10px 0px 20px rgba(55, 81, 255, 0.1);
  overflow: hidden;
`;

const HamburgerContainer = styled.div`
  padding-top: 2em;
  padding-left: 2em;
  cursor: pointer;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.1);
  }
`;

const SideBarText = styled.h2<{ isExpanded: boolean }>`
  font-size: 14px;
  padding-top: 1em;
  line-height: 0;
  font-weight: 400;
  color: #214160;
  display: ${({ isExpanded }) => (isExpanded ? "block" : "none")};
  transition: opacity 0.3s ease;
`;

const StyledNavLink = styled(NavLink)`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: 1em 0;
  transition: all 0.3s ease;
  &:hover {
    background-color: rgba(107, 137, 255, 0.1);
    transform: scale(1.05);
  }
  &.active {
    background-color: #01a8ce;
    border-left: 3.5px solid #01a8ce;
    ${SideBarText} {
      color: #fff;
    }
  }
`;
